// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qg-1";
export var stateContainer = "_qg-0";